
import TenureDetails from "../pages/dashboard/admin/assets/details/TenureDetails";
import AdminAssets from "../pages/dashboard/admin/assets/Index";
import AdminCurves from "../pages/dashboard/admin/curves";
import AdminPrice from "../pages/dashboard/admin/price/Index";
import PricesDetailsPage from "../pages/dashboard/admin/price/PricesDetailsPage";
import Users from "../pages/dashboard/admin/user";
import YCR from "../pages/dashboard/admin/ycr/YCR";
import Profile from "../pages/dashboard/Profile";
import Analytics from "../pages/dashboard/user/analytics/Analytics";
import Assets from "../pages/dashboard/user/assets";
import Prices from "../pages/dashboard/user/prices";
export const route = [
    {
        path: "/data/asset",
        ele: <Assets />,
        permission: 'user',
    },
    {
        path: "/analytics",
        ele: <Analytics />,
        permission: 'user',
    },
    {
        path: "/data/prices",
        ele: <Prices />,
        permission: 'user',
    },
    {
        path: "/data/prices/:slug",
        ele: <PricesDetailsPage />,
        permission: 'user',
    },
    {
        path: "/data/asset/:slug",
        ele: <TenureDetails />,
        permission: 'user',
    },
    {
        path: "/profile",
        ele: <Profile />,
        permission: 'user',
    },
    // admin Routes
    {
        path: "/admin/ycr",
        ele: <YCR />,
        permission: 'admin',
    },
    {
        path: "/admin/curves",
        ele: <AdminCurves />,
        permission: 'admin',
    },
    {
        path: "/admin/data/asset",
        ele: <AdminAssets />,
        permission: 'admin',
    },
    {
        path: "/admin/data/asset/:slug",
        ele: <TenureDetails />,
        permission: 'admin',
    },
    {
        path: "/admin/data/prices",
        ele: <AdminPrice />,
        permission: 'admin',
    },
    {
        path: "/curves",
        ele: <AdminCurves />,
        permission: 'user',
    },
    {
        path: "/admin/user",
        ele: <Users />,
        permission: 'admin',
    },
    {
        path: "/admin/data/prices/:slug",
        ele: <PricesDetailsPage />,
        permission: 'admin',
    },
]
